<template>
      <div class="row">
        <div class="col-md-12">
            <div class="form-inline">
                <label class="mr-2">Filter Status</label>
                <select class="form-control" :value="status" @change="changeStatus">
                    <option value="all">All</option>
                    <option value="pending">Pending</option>
                    <option value="accepted">Accepted</option>
                    <option value="rejected">Rejected</option>
                    <option value="cancelled">Cancelled</option>
                </select>
            </div>
            <div class="clearfix"><br></div>
        </div>
        <div class="col-md-4 mb-2">
            <div class="form-inline">
                <label class="mr-2">Showing</label>
                <select class="form-control" v-model="meta.per_page" @change="loadPerPage">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
                <label class="ml-2">Entries</label>
            </div>
        </div>

        <div class="col-md-4 offset-md-4">
            <div class="form-inline float-right mb-3">
                <label class="mr-2 ">Search</label>
                <input type="text" class="form-control" placeholder="Name, email, phone, iCare" @input="search">
            </div>
        </div>

        <div class="col-md-12">
            <CDataTable striped hover bordered :items="items" :fields="fields" :sorter="{ external: true }" :sorter-value="sorterValue" @update:sorter-value="onSorterChange" show-empty>
              <template #name="{item}">
                <td>{{ item.name || '-' }}</td>
              </template>
              <template #email="{item}">
                <td>{{ item.email || '-' }}</td>
              </template>
              <template #phone="{item}">
                <td>{{ item.phone || '-' }}</td>
              </template>
              <template #icare_name="{item}">
                <td>{{ item.icare_name || '-' }}</td>
              </template>
              <template #icl_name="{item}">
                <td>{{ item.icl_name || '-' }}</td>
              </template>
              <template #created_at="{item}">
                <td>{{ frontEndDateFormat(item.created_at) }}</td>
              </template>
              <template #status_label="{item}">
                <td>
                  <CBadge :color="statusColor(item.status_label)">{{ item.status_label || '-' }}</CBadge>
                </td>
              </template>
              <template #action="{item}">
                <td>
                  <CButton size="sm" variant="primary" color="success" @click="show(item.id)">Detail</CButton>
                </td>
              </template>
              <template #no-items-view>
                <div class="text-center text-muted my-3">No join requests found</div>
              </template>
            </CDataTable>
        </div>

        <div class="col-md-6">
            <p>Showing {{ meta.from || 0 }} to {{ meta.to || 0 }} of {{ meta.total || 0 }} items</p>
        </div>

        <div class="col-md-6">
            <b-pagination
                v-model="meta.current_page"
                :total-rows="meta.total"
                :per-page="meta.per_page"
                align="right"
                @change="changePage"
                aria-controls="dw-datatable"
            ></b-pagination>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';

const STATUS_COLORS = {
  Pending: 'warning',
  Accepted: 'success',
  Rejected: 'danger',
  Cancelled: 'secondary',
  Done: 'secondary',
}

export default {
  name: 'Table',
  props: {
    items: {
        type: Array,
        required: true
    },
    fields: {
        type: Array,
        required: true
    },
    meta: {
        required: true
    },
    status: {
        type: String,
        default: 'all'
    },
    sorterValue: {
        type: Object,
        default: () => ({ column: 'created_at', asc: false })
    },
  },
   methods:{
      onSorterChange(v) {
          this.$emit('sort', {
              sortBy: v.column || 'created_at',
              sortDesc: v.asc === false
          })
      },

      loadPerPage() {
          this.$emit('per_page', this.meta.per_page)
      },

      changeStatus(e) {
          this.$emit('status', e.target.value)
      },

      changePage(val) {
          this.$emit('pagination', val)
      },

      search: _.debounce(function (e) {
          this.$emit('search', e.target.value)
      }, 500),

      show: function (id) {
          this.$emit('show', id)
      },

      statusColor: function (label) {
          return STATUS_COLORS[label] || 'secondary'
      },

      frontEndDateFormat: function(date) {
        if (!date) return '-'
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY');
      },
  }

}
</script>
